import { inject, observer } from 'mobx-react';
import React from 'react';
import DatePicker from 'react-datepicker';
import { format, isValid, toDate } from "date-fns";
import moment from 'moment';
import ReleaseIncidentDataStore from '../store/release-incident-store';
@inject('ReleaseIncidentDataStore')
@observer
class EstimatedLeakStartComponent extends React.Component {
  constructor(props) {
    super(props);
    var d = this.props.ReleaseIncidentDataStore.dateSelection.estimatedLeakStart!='' && this.props.ReleaseIncidentDataStore.dateSelection.estimatedLeakStart!==null?moment(this.props.ReleaseIncidentDataStore.dateSelection.estimatedLeakStart):'';
    this.state = {
        estimatedLeakStart: typeof this.props.ReleaseIncidentDataStore.dateSelection.estimatedLeakStart!='undefined' && this.props.ReleaseIncidentDataStore.dateSelection.estimatedLeakStart && d.isValid() ?(moment(this.props.ReleaseIncidentDataStore.dateSelection.estimatedLeakStart).toDate()):''
    }
  }

  handleDateChange = async(estimes) => {
    let estime = estimes!='' && typeof estimes!='undefined' && estimes!=null?moment(estimes).toDate():'';
    await ReleaseIncidentDataStore.estimatedLeakStartUpdate(estime);

    //console.log('estime',estime);

    this.setState(state => ({
        estimatedLeakStart: (estime!='' && typeof estime!='undefined' && estime!==null?estime:''),
    }))
  }

  render() {
    //var {dateSelection} = this.props.ReleaseIncidentDataStore;
    
    return(
      <div>
          <DatePicker
              className='form-control'
              selected={this.state.estimatedLeakStart!='' && typeof this.state.estimatedLeakStart!='undefined' && this.state.estimatedLeakStart!=null?this.state.estimatedLeakStart:''}
              value={this.state.estimatedLeakStart!='' && typeof this.state.estimatedLeakStart!='undefined' && this.state.estimatedLeakStart!=null?this.state.estimatedLeakStart:''}
              shouldCloseOnSelect={false}
              onChange={(etime)=>{
                console.log('changes',etime)

                this.handleDateChange(etime)
              }}
              showTimeInput
              timeInputLabel="Time:"
              dateFormat="MM-dd-yyy HH:mm"
              readOnly={this.props.isDisabled?true:false}
              //timeFormat="HH:mm"
          />
          {((this.props.submitInfo==2 || this.props.submitInfo==3) && this.state.estimatedLeakStart=='' ) && <span className="error_form">Required</span>}
      </div>
    )
  }
}

export default EstimatedLeakStartComponent;